<template>
  <div class="camera" v-if="display">
    <div class="camera_close_container" @click="closeCamera">X</div>
    <div class="camera_container">
      <div ref="cvs" style="position:absolute;width:100%;top:10vh;left:0;" :hidden="!shoted"></div>
      <video ref="cameraPlayer" style="position:absolute;top:10vh;left:0;width:100%;" :hidden="shoted"></video>
      <div class="camera_container_btn_box">
        <div class="camera_container_btn">
          <i class="el-icon-close" @click="closeCamera"></i>
        </div>
        <div class="camera_container_btn">
          <i class="el-icon-camera" v-if="!shoted && !uploading" @click="cameraShot"></i>
          <i class="el-icon-finished" v-if="shoted && !uploading" @click="cameraResult"></i>
          <i class="el-icon-loading" v-if="uploading"></i>
        </div>
        <div class="camera_container_btn">
          <i class="el-icon-refresh" @click="cameraSwitch" v-if="!shoted && !uploading"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { uploadFile } from '../api/api';
  export default {
    name: "camera",
    data(){
      return {
        display:false,
        shoted:false,
        uploading:true,
        faceMode:false,
        cameraRecorder:null,
        recordedChunks:[],
        mediaStreamTrack:null,
        result:null,
        canvas:null,
        ctx:null
      }
    },
    mounted(){

    },
    methods:{
      openCamera(){
        this.display = true;
        this.uploading = true;
        this.faceMode = false;
        this.cameraInit();
      },
      closeCamera(){
        if(this.shoted){
          this.shoted = false;
        }else{
          this.clearCamera();
          this.faceMode = false;
          this.display = false;
        }
      },
      clearCamera(){
        this.$refs.cameraPlayer.srcObject = null;
        if(this.cameraRecorder != null){
          this.cameraRecorder.stop();
        }
        if(this.mediaStreamTrack!=null){
          this.mediaStreamTrack.getVideoTracks().forEach(track => {
            track.stop();
          });
        }
        this.mediaStreamTrack = null;
        this.cameraRecorder = null;
        this.shoted = false;
        this.uploading = false;
        this.recordedChunks = [];
      },
      async cameraInit(){
        this.recordedChunks = [];
        navigator.getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia;
        if(navigator.mediaDevices){
          let stream;
          try{
            stream = await navigator.mediaDevices.getUserMedia({audio:false,video:{facingMode:{exact:(this.faceMode ?  'user' : 'environment')}}});
          }catch(e){
            try{
              stream = await navigator.mediaDevices.getUserMedia({audio:false,video:{facingMode:(this.faceMode ?  'user' : 'environment')}});
            }catch (e2){
              try{
                stream = await navigator.mediaDevices.getUserMedia({audio:false,video:true});
              }catch (e3){
                this.$alert(e3.message,'错误提示',{
                  center:true,
                  type:'error',
                  confirmButtonText: '确定',
                  callback: action => {

                  }
                });
              }
            }
          }
          this.mediaStreamTrack = stream;
          this.$refs.cameraPlayer.srcObject = stream;
          this.$refs.cameraPlayer.play();
          this.uploading = false;
        }
      },
      cameraShot(){
        if(this.canvas==null){
          this.canvas = document.createElement("canvas");
          let vw = this.$refs.cameraPlayer.videoWidth;
          let vh = this.$refs.cameraPlayer.videoHeight;
          this.canvas.width = Math.min(vw,window.innerWidth);
          this.canvas.height = Math.min(vh,window.innerWidth * vh / vw);
          this.$refs.cvs.paddingTop = (this.$refs.cameraPlayer.height - this.canvas.height) / 2;
          this.$refs.cvs.appendChild(this.canvas);
          this.ctx = this.canvas.getContext("2d");
        }
        this.ctx.drawImage(this.$refs.cameraPlayer, 0, 0, this.canvas.width, this.canvas.height);
        this.shoted = true;
      },
      cameraSwitch(){
        this.clearCamera();
        this.uploading = true;
        this.faceMode = !this.faceMode;
        this.cameraInit();
      },
      cameraResult(){
        this.uploading = true;
        let dataUrl = this.canvas.toDataURL("image/png");
        fetch(dataUrl).then(response => response.blob()).then(blob => {
          let file = new File([blob],'camera_'+Math.round(Math.random()*8999+1000)+'_'+(new Date().valueOf())+'.png',{type:blob.type});
          let params = new FormData();
          params.append('files',file);
          uploadFile(params).then(res => {
            if(res && res.status === 0){
              let data = res.data[0];
              if(data && parseInt(data.status) === 0){
                this.$emit('cameraResult',data);
                this.shoted = false;
                this.closeCamera();
              }else{
                this.$alert(data.message,'错误提示',{
                  center:true,
                  type:'error',
                  confirmButtonText: '确定',
                  callback: action => {

                  }
                });
              }
            }else{
              this.$alert(res.message,'错误提示',{
                center:true,
                type:'error',
                confirmButtonText: '确定',
                callback: action => {

                }
              });
            }
          }).catch(e => {
            this.$alert(e.message,'错误提示',{
              center:true,
              type:'error',
              confirmButtonText: '确定',
              callback: action => {

              }
            });
          }).finally(f => {
            this.uploading = false;
          });
        });
      }
    }
  }
</script>

<style scoped>
  .camera {
    position:absolute;
    top:0;
    left:0;
    display: inline-block;
    width:100%;
    height:94vh;
    background-color:rgba(0,0,0,0.9);
    z-index:99;
    overflow-y:scroll;
  }
  .camera_container {
    position:absolute;
    top:0;
    left:0;
    width:100%;
    height:94vh;
  }
  .camera_close_container {
    position:absolute;
    top:1vh;
    left:0;
    text-align:right;
    width:97%;
    margin-right:3%;
    font-size:1rem;
    color:white;
    cursor:pointer;
    z-index:999;
  }
  .camera_container_btn_box {
    position:absolute;
    top:80vh;
    left:0;
    width:100%;
    height:5rem;
    text-align:center;
  }
  .camera_container_btn {
    float:left;
    height:3rem;
    width:30%;
    margin-left:3%;
    line-height:3rem;
    border-radius:1.5rem;
    font-size:3rem;
    color:rgba(255,255,255,0.3);
  }
</style>



// WEBPACK FOOTER //
// src/components/camera.vue